import React from 'react'
import { ToolkitContentPage } from '../../components/ToolkitContentPage'
import toolkitContent from '../../data/toolkitContent.json'

export const InstitutionPoliciesPage: React.FC = () => {
  // Find the Institution Policies content from our JSON data
  const institutionContent = toolkitContent.find(
    (item) => item.title === 'Institution Policies'
  )

  if (!institutionContent) {
    return (
      <div className="text-center py-12">
        <h1 className="text-2xl font-bold text-[#3C2416] mb-4">
          Page Not Found
        </h1>
        <p className="text-[#713d43]">
          The requested content could not be found.
        </p>
      </div>
    )
  }

  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Institution', path: '/toolkit/institution' },
    { label: 'Policies', path: '/toolkit/institution/policies', isActive: true }
  ]

  return (
    <ToolkitContentPage
      title={institutionContent.title}
      htmlContent={institutionContent.html_content}
      breadcrumbs={breadcrumbs}
    />
  )
}
